<nb-card>
    <nb-card-header>Informativa sulla privacy </nb-card-header>
    <nb-card-body>
        <div
            class="info"
            [innerHTML]="current_info?.info.it"
        ></div>
    </nb-card-body>
    <nb-card-footer><button
            nbButton
            (click)="closeModal()"
        >Chiudi</button></nb-card-footer>
</nb-card>
